module.exports = __webpack_public_path__ + "static/img/declaration-icon.1c3a8899.png";